import { DoqType, ResponsiveDoqWithSpeechBubble } from '@ardoq/doq';
import { PrimaryButton } from '@ardoq/button';
import { Icon, IconName } from '@ardoq/icons';
import { FlexBox, Stack } from '@ardoq/layout';
import { KnowledgeBaseLink } from '@ardoq/knowledge-base';
import { openUrlInNewTab } from '@ardoq/common-helpers';
import { EmptyStatesDoqContainer } from '@ardoq/graph';
import { t, type I18nLocale } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { connect } from '@ardoq/rxbeach';
import { map } from 'rxjs';

type NoTagsDoqProps = {
  doqType: DoqType;
  includeActions?: boolean;
  i18nLocale: I18nLocale;
};

const NoTagsDoqBase = ({
  doqType,
  includeActions = true,
  i18nLocale,
}: NoTagsDoqProps) => {
  return (
    <EmptyStatesDoqContainer>
      <ResponsiveDoqWithSpeechBubble
        doqType={doqType}
        title={t(
          i18nLocale,
          'tabview:graphViews.emptyState.noTags.title',
          'No tags to show'
        )}
        message={
          <Stack gap="xlarge">
            <FlexBox gap="medium">
              {t(
                i18nLocale,
                'tabview:graphViews.emptyState.noTags.message1',
                'To use this view, add tags to your components.'
              )}
            </FlexBox>
            <FlexBox gap="medium">
              {t(
                i18nLocale,
                'tabview:graphViews.emptyState.noTags.message2',
                'Check out the knowledge base on how to use tags.'
              )}
            </FlexBox>
          </Stack>
        }
        buttonLabel={
          includeActions ? (
            <PrimaryButton>
              {t(
                i18nLocale,
                'tabview:graphViews.emptyState.noTags.openKnowledgeBase',
                'Open knowledge base'
              )}{' '}
              <Icon iconName={IconName.OPEN_IN_NEW} />
            </PrimaryButton>
          ) : undefined
        }
        onButtonClick={
          includeActions
            ? () => openUrlInNewTab(KnowledgeBaseLink.USING_TAGS)
            : undefined
        }
      />
    </EmptyStatesDoqContainer>
  );
};

export const NoTagsDoq = connect(
  NoTagsDoqBase,
  i18nLocale$.pipe(map(i18nLocale => ({ i18nLocale })))
);
